import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { ChargeSlab } from './chargeSlab.types';

export interface ChargeSlabParams {
  categoryId?: string;
  agentType?: string;
  row?: number;
  fetch?: number;
  search?: string;
}

export const getChargeManagementDetailList = (client: AxiosInstance) => async (params?: ChargeSlabParams) => {
  return (
    await client.get<PaginatedApiResponse<ChargeSlab[]>>(API_ROUTES.CHARGE_MANAGEMENT_DETAIL_LIST, {
      params: params || {},
    })
  ).data;
};

export const getChargeManagementDetail = (client: AxiosInstance) => async (chargeCategoryId?: string) => {
  return (
    await client.get<ApiResponse<ChargeSlab>>(API_ROUTES.GET_CHARGE_MANAGEMENT_DETAIL, {
      params: { chargeCategoryId: chargeCategoryId || '' },
    })
  ).data;
};

export const chargeSlabQueries = {
  all: () => ['chargeSlab'],
  list: (params?: ChargeSlabParams) =>
    queryFactoryOptions<PaginatedApiResponse<ChargeSlab[]>>({
      queryKey: [...chargeSlabQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getChargeManagementDetailList(client)(params),
    }),
  detail: (chargeCategoryId?: string) =>
    queryFactoryOptions<ApiResponse<ChargeSlab>>({
      queryKey: [...chargeSlabQueries.all(), 'detail', chargeCategoryId],
      queryFn: (client: AxiosInstance) => () => getChargeManagementDetail(client)(chargeCategoryId),
    }),
};
